import DropdownSingleSelectQuestion from './DropdownSingleSelectQuestion';

export default DropdownSingleSelectQuestion;
